import { BeforeYouSyncModal, BeforeYouSyncModalProps } from "./BeforeYouSyncModal"

export const BeforeYouSyncModalSkydio = (props: BeforeYouSyncModalProps) => {
    return (
        <BeforeYouSyncModal {...props}>
            <h4 className="text-gray-0 text-center mt-4">
                Before continuing, ensure all your flights have finished syncing to the cloud.
                <br />
                <br />
                <a
                    className="underline text-blue-500 hover:text-blue-300"
                    href="https://support.skydio.com/hc/en-us/articles/14298828228251-How-to-sync-your-drone-to-Skydio-Cloud"
                    target="about:blank"
                >
                    How to sync to Skydio Cloud
                </a>
            </h4>
        </BeforeYouSyncModal>
    )
}
